import { User } from '@prisma/client'
import { Form, Input, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = {
  user: User
} & StepProps

export const StepTone: React.FC<Props> = ({ user, ...props }) => {
  const validateSocialUrl = (_: any, value: string) => {
    if (
      value?.includes('instagram.com') ||
      value?.includes('linkedin.com') ||
      value?.includes('facebook.com') ||
      value?.includes('x.com') ||
      value?.includes('google.com') ||
      !value
    ) {
      return Promise.resolve()
    }
    return Promise.reject(
      new Error(
        'Please enter a valid social media URL (Instagram, LinkedIn, Facebook, X or Google Business Profile)',
      ),
    )
  }

  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>
          Which social account should I study to match your tone?
        </TitlePrimary>

        <Typography.Text className="mb-10">
          I can learn your tone by analyzing a social media account. <br /> Just
          drop one public profile you like—yours or someone else’s—and I’ll use
          it to craft posts that match the style.
        </Typography.Text>

        <Form.Item
          name={['tone', 'socialAccountUrl']}
          label="Social Account Link"
          rules={[{ validator: validateSocialUrl }]}
          validateTrigger="onBlur"
        >
          <Input placeholder="https://www.instagram.com/marblism.ai" />
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
